module.exports = __webpack_public_path__ + "static/media/logoAuth.c0d57987.svg";